/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'upload': {
    width: 24,
    height: 23,
    viewBox: '0 0 24 23',
    data: '<path pid="0" _fill="#fff" d="M23.312 10.844a.685.685 0 0 0-.687.687v6.255a3.086 3.086 0 0 1-3.082 3.082H4.457a3.086 3.086 0 0 1-3.082-3.082V11.43a.685.685 0 0 0-.687-.688.685.685 0 0 0-.688.688v6.356a4.462 4.462 0 0 0 4.457 4.457h15.086A4.462 4.462 0 0 0 24 17.786v-6.255a.688.688 0 0 0-.688-.687z"/><path pid="1" _fill="#fff" d="M8.114 5.547l3.198-3.199v13.95c0 .383.306.689.688.689a.685.685 0 0 0 .688-.688V2.349l3.198 3.198a.696.696 0 0 0 .484.204.663.663 0 0 0 .484-.204.686.686 0 0 0 0-.973l-4.37-4.37A.696.696 0 0 0 12 0a.666.666 0 0 0-.484.204l-4.37 4.37a.686.686 0 1 0 .968.973z"/>'
  }
})
